import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { DialogService } from 'primeng/dynamicdialog';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { authInterceptor } from './app/interceptors/auth.interceptor';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideTranslateService({
            loader: provideTranslateHttpLoader(),
            fallbackLang: 'de',
            lang: 'de',
        }),
        MessageService,
        DialogService,
        TranslateModule,
        { provide: LOCALE_ID, useValue: 'de-DE' }
    ]
};
